import React from "react";
import "./MovingBars.scss";

interface IProps {
    count?: number
    direction?: 'both' | 'right' | 'left'
    className?: string
}

export function MovingBars({ count = 3, direction = 'right', className }: IProps) {
    return (
        <div className={`moving-bars direction-${direction} ${className}`}>
            {(new Array(count)).fill(0).map((nil, index) => {
                return <div key={index} />
            })}
        </div>
    )
}
